import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from '@angular/router';
import Swal from 'sweetalert2';
import { AuthenticationService } from 'app/auth/service';

// tb_perfil_login: 1 Administrador Geral, 2 Administrador, 6 Financeiro.
// A API valida o perfil de novo (PerfisGuard); aqui só evita abrir a tela para quem não tem acesso.
export const PERFIS_FINANCEIRO = [1, 2, 6];

// Rota com data: { perfis: [...] } só abre para esses perfis. Usar depois do AuthGuard.
@Injectable({
	providedIn: 'root'
})
export class PerfilGuard implements CanActivate {
	constructor(private authenticationService: AuthenticationService, private router: Router) { }

	canActivate(route: ActivatedRouteSnapshot): boolean | UrlTree {
		const perfis: number[] = route.data?.perfis || [];
		// Sem sessão quem responde é o AuthGuard (tela de login).
		if (!perfis.length || !localStorage.getItem('currentUser') || perfis.includes(this.authenticationService.perfilLogin)) {
			return true;
		}
		Swal.fire({
			title: 'Acesso restrito',
			text: 'Seu perfil não tem acesso a esta tela.',
			icon: 'warning',
			confirmButtonText: 'Ok',
			confirmButtonColor: '#161D31',
		});
		return this.router.parseUrl(route.data?.semPermissao || '/fechamento');
	}
}
